"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialColorEditViewModel = instanceOfMaterialColorEditViewModel;
exports.MaterialColorEditViewModelFromJSON = MaterialColorEditViewModelFromJSON;
exports.MaterialColorEditViewModelFromJSONTyped = MaterialColorEditViewModelFromJSONTyped;
exports.MaterialColorEditViewModelToJSON = MaterialColorEditViewModelToJSON;
exports.MaterialColorEditViewModelToJSONTyped = MaterialColorEditViewModelToJSONTyped;
/**
 * Check if a given object implements the MaterialColorEditViewModel interface.
 */
function instanceOfMaterialColorEditViewModel(value) {
    return true;
}
function MaterialColorEditViewModelFromJSON(json) {
    return MaterialColorEditViewModelFromJSONTyped(json, false);
}
function MaterialColorEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mcMaterialColorNo': json['mcMaterialColorNo'] == null ? undefined : json['mcMaterialColorNo'],
        'mcOrgId': json['mcOrgId'] == null ? undefined : json['mcOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'mcBackstageKey': json['mcBackstageKey'] == null ? undefined : json['mcBackstageKey'],
        'mcMaterialId': json['mcMaterialId'] == null ? undefined : json['mcMaterialId'],
        'mcMaterialNo': json['mcMaterialNo'] == null ? undefined : json['mcMaterialNo'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'mcColor': json['mcColor'] == null ? undefined : json['mcColor'],
        'pcsColorStyleName': json['pcsColorStyleName'] == null ? undefined : json['pcsColorStyleName'],
        'mcLiveDateS': json['mcLiveDateS'] == null ? undefined : json['mcLiveDateS'],
        'mcLiveDateE': json['mcLiveDateE'] == null ? undefined : json['mcLiveDateE'],
        'mcSampLiveDateS': json['mcSampLiveDateS'] == null ? undefined : json['mcSampLiveDateS'],
        'mcSampLiveDateE': json['mcSampLiveDateE'] == null ? undefined : json['mcSampLiveDateE'],
        'mcRfid': json['mcRfid'] == null ? undefined : json['mcRfid'],
        'mcActive': json['mcActive'] == null ? undefined : json['mcActive'],
        'ciCompanyName': json['ciCompanyName'] == null ? undefined : json['ciCompanyName'],
        'psProductSeriesName': json['psProductSeriesName'] == null ? undefined : json['psProductSeriesName'],
        'msCostPrice': json['msCostPrice'] == null ? undefined : json['msCostPrice'],
        'msCurrency': json['msCurrency'] == null ? undefined : json['msCurrency'],
        'msDeposit': json['msDeposit'] == null ? undefined : json['msDeposit'],
        'msSaveCount': json['msSaveCount'] == null ? undefined : json['msSaveCount'],
        'msLiveDateS': json['msLiveDateS'] == null ? undefined : json['msLiveDateS'],
        'msLiveDateE': json['msLiveDateE'] == null ? undefined : json['msLiveDateE'],
        'msSampLiveDateS': json['msSampLiveDateS'] == null ? undefined : json['msSampLiveDateS'],
        'msSampLiveDateE': json['msSampLiveDateE'] == null ? undefined : json['msSampLiveDateE'],
        'msRfid': json['msRfid'] == null ? undefined : json['msRfid'],
        'msActive': json['msActive'] == null ? undefined : json['msActive'],
        'msOther': json['msOther'] == null ? undefined : json['msOther'],
        'msSalesAmount': json['msSalesAmount'] == null ? undefined : json['msSalesAmount'],
        'msApidate': json['msApidate'] == null ? undefined : json['msApidate'],
        'msApitype': json['msApitype'] == null ? undefined : json['msApitype'],
    };
}
function MaterialColorEditViewModelToJSON(json) {
    return MaterialColorEditViewModelToJSONTyped(json, false);
}
function MaterialColorEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mcMaterialColorNo': value['mcMaterialColorNo'],
        'mcOrgId': value['mcOrgId'],
        'oName': value['oName'],
        'mcBackstageKey': value['mcBackstageKey'],
        'mcMaterialId': value['mcMaterialId'],
        'mcMaterialNo': value['mcMaterialNo'],
        'mdProduct': value['mdProduct'],
        'mcColor': value['mcColor'],
        'pcsColorStyleName': value['pcsColorStyleName'],
        'mcLiveDateS': value['mcLiveDateS'],
        'mcLiveDateE': value['mcLiveDateE'],
        'mcSampLiveDateS': value['mcSampLiveDateS'],
        'mcSampLiveDateE': value['mcSampLiveDateE'],
        'mcRfid': value['mcRfid'],
        'mcActive': value['mcActive'],
        'ciCompanyName': value['ciCompanyName'],
        'psProductSeriesName': value['psProductSeriesName'],
        'msCostPrice': value['msCostPrice'],
        'msCurrency': value['msCurrency'],
        'msDeposit': value['msDeposit'],
        'msSaveCount': value['msSaveCount'],
        'msLiveDateS': value['msLiveDateS'],
        'msLiveDateE': value['msLiveDateE'],
        'msSampLiveDateS': value['msSampLiveDateS'],
        'msSampLiveDateE': value['msSampLiveDateE'],
        'msRfid': value['msRfid'],
        'msActive': value['msActive'],
        'msOther': value['msOther'],
        'msSalesAmount': value['msSalesAmount'],
        'msApidate': value['msApidate'],
        'msApitype': value['msApitype'],
    };
}
